import { Injectable } from '@angular/core';

import { Principal } from '../shared/auth/principal.service';
import { AuthServerProvider } from '../shared/auth/auth-jwt.service';

@Injectable()
export class LoginService {

	constructor(
		private principal: Principal,
		private authServerProvider: AuthServerProvider
	) {
		
	}

	login(credentials: any, callback?: any) {
		const cb = callback || function() { };

		return new Promise((resolve, reject) => {
			this.authServerProvider.login(credentials).subscribe((data) => {
				this.authServerProvider.resetInterceptorState?.();
				this.principal.identity(true).then((account) => {
					if (account !== null) {
						//do some operations if needed
					}
					resolve(data);
				});
				return cb();
			}, (err) => {
				reject(err);
				return cb(err);
			});
		});
	}

	logout() {
		this.authServerProvider.logout().subscribe();
		this.principal.authenticate(null);
	}
	
}